import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { EventTrace } from "@/api/types/event-tracer";
import { useEventTraceSingle } from "@/services/TablePage/eventTracer";
import { showServerError } from "@/utils";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import EventTraceCards from "@/components_v3/statistics/EventTraceCards.vue";
import { getOneEventTrace } from "@/api/event-tracer";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTraceSingle',
  setup(__props) {

const { getCards, getFields } = useEventTraceSingle();
const route = useRoute();

const eventID = ref(0);
const event = ref<EventTrace>(null);
const cards = ref([]);
const isLoading = ref(true);

onBeforeMount(() => {
    eventID.value = route.params.id;
    document.title = `Событие ${eventID.value}`;

    getEvent();
});

const getEvent = async () => {
    try {
        const columns = getFields();

        const { data } = await getOneEventTrace({
            columns,
            filters: [{ column: 'event_id', values: [Number(eventID.value)], operator: 'in' }],
        });

        event.value = data[0];
        cards.value = getCards(data[0]);
    } catch (err) {
        showServerError(err, 'Ошибка загрузки события');
    } finally {
        isLoading.value = false;
    }
};


return { __sfc: true,getCards, getFields, route, eventID, event, cards, isLoading, getEvent, PageLayout, EventTraceCards }
}

})